export default __webpack_public_path__ + "static/media/01_Manual_Programa_de_Excelência_Cargill_1.376b5d8d.pdf";